// Phase T2.0A Prompt 2.2 — capacity + roster count helpers.
//
// Single source of truth on the frontend for interpreting max_entries:
//   • singles: max_entries === player capacity
//   • doubles: max_entries === team capacity; player capacity = max_entries * 2
//
// Count of registered players is DISTINCT profile ids across both player
// slots — matches the DB RPC rule so an incomplete registration counts as
// 1 player, not 2, and a confirmed team counts as exactly 2.

export function playerCapacity(eventType, maxEntries) {
  if (maxEntries == null) return null;
  return eventType === 'doubles' ? maxEntries * 2 : maxEntries;
}

export function registeredPlayerCount(entries = []) {
  const ids = new Set();
  for (const e of entries || []) {
    if (e.player1_profile_id) ids.add(e.player1_profile_id);
    if (e.player2_profile_id) ids.add(e.player2_profile_id);
  }
  return ids.size;
}

// Team registration count. Doubles-only meaningful metric — a "team" here
// means an entry row with a confirmed partner. Incomplete entries (TBD /
// looking) count for the player-side math but not for the team count.
export function registeredTeamCount(entries = []) {
  return (entries || []).filter((e) => e.partner_status === 'confirmed').length;
}

export function eventIsFull(entries = [], eventType, maxEntries) {
  const cap = playerCapacity(eventType, maxEntries);
  if (cap == null) return false;
  return registeredPlayerCount(entries) >= cap;
}

// e.g. "2 / 40 Players Registered" or "40 / 40 Players Registered · FULL"
export function playerCountLabel(entries, eventType, maxEntries) {
  const n = registeredPlayerCount(entries);
  const cap = playerCapacity(eventType, maxEntries);
  if (cap == null) return `${n} Player${n === 1 ? '' : 's'} Registered`;
  const suffix = n >= cap ? ' · FULL' : '';
  return `${n} / ${cap} Players Registered${suffix}`;
}
